import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import Invite from './Invite';
import Participant from './Participant';
import { getTransactionAccessSelector } from 'store/selectors/transaction';

import styles from './styles.module.scss';
import useIsProjectRoute from 'hooks/use-is-project-route';
import { Wrapper } from 'components';
import {
  TransactionRoomWrapper,
  VARIANTS,
} from 'pages/Workshop/Transactions/components/TransactionRoomWrapper';

const Participants = (props) => {
  const { className, participants, isPending, participantsInContact } = props;
  const isProject = useIsProjectRoute();
  const { fullAccess } = useSelector(getTransactionAccessSelector);

  return (
    <div className={classNames(styles.participants, className)}>
      <div className={styles.title}>
        <Invite />
      </div>
      <TransactionRoomWrapper
        variant={VARIANTS.CONFETTI_BLUE}
        className={classNames({ [styles.marginTop]: !fullAccess })}
      >
        <Wrapper isPending={isPending} spinnerClassname={styles.spinnerMarginTop}>
          <div className={styles.participantContainer}>
            <p className={styles.text}>Invited to {isProject ? 'Project' : 'Transaction'}</p>
            {participants?.length === 0 ? (
              <div className={styles.emptyContainer}>No Invitees</div>
            ) : (
              participants?.map((participant, idx) => (
                <div key={participant?.Id}>
                  <Participant {...participant} participantsInContacts={participantsInContact} />
                </div>
              ))
            )}
          </div>
        </Wrapper>
      </TransactionRoomWrapper>
    </div>
  );
};

Participants.propTypes = {
  className: PropTypes.string,
  participants: PropTypes.arrayOf(PropTypes.shape({})),
  isPending: PropTypes.bool,
  participantsInContact: PropTypes.bool,
};

Participants.defaultProps = {
  className: '',
  participants: [],
  isPending: false,
  participantsInContact: false,
};

export default Participants;
